import './sanford/style';
import FormStructure from './sanford/form_structure';

export default FormStructure;